import { render, staticRenderFns } from "./OfferDelete.vue?vue&type=template&id=10151756&scoped=true&"
import script from "./OfferDelete.vue?vue&type=script&lang=js&"
export * from "./OfferDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10151756",
  null
  
)

export default component.exports